<p-breadcrumb
  [model]="[
    { label: 'Multas', routerLink: ['/late-fee-policies'] },
    {
      label: lateFeePolicyId() ? 'Editar Multa' : 'Nova Multa',
      routerLink: lateFeePolicyId()
        ? ['/late-fee-policies/update/' + lateFeePolicyId()]
        : ['/late-fee-policies/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(lateFeePolicyId()){
        <h5 class="font-bold">Editar Multa</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Nova Multa</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if(lateFeePolicyId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/late-fee-policies"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card space-y-5 w-full">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="w-full">
      <label for="name"> Nome *</label>
      <input
        pInputText
        type="text"
        formControlName="name"
        class="w-full"
        placeholder="Ex: Multa por atraso padrão"
      />
      <app-form-error [control]="formGroup.get('name')" />
      <app-form-server-error [control]="formGroup.get('name')" />
    </div>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="type"> Tipo *</label>
        <p-select
          formControlName="type"
          inputId="type"
          [options]="typeOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o tipo"
          class="w-full"
        >
        </p-select>
        <app-form-error [control]="formGroup.get('type')" />
        <app-form-server-error [control]="formGroup.get('type')" />
      </div>

      <div class="w-full">
        <label for="value"> Valor *</label>
        @if(isPercentage()){
        <p-inputNumber
          formControlName="value"
          inputId="value"
          mode="decimal"
          locale="en-US"
          suffix=" %"
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [min]="0.01"
          [max]="100"
          class="w-full"
          placeholder="Ex: 2.00 %"
        ></p-inputNumber>
        }@else {
        <p-inputNumber
          formControlName="value"
          inputId="value"
          mode="currency"
          currency="USD"
          locale="en-US"
          [min]="0.01"
          class="w-full"
          placeholder="Ex: $10.00"
        ></p-inputNumber>
        }
        <app-form-error [control]="formGroup.get('value')" />
        <app-form-server-error [control]="formGroup.get('value')" />
      </div>
    </div>

    <div class="flex flex-wrap xl:flex-nowrap gap-5">
      <div class="w-full">
        <label for="graceDays"> Dias de carência *</label>
        <p-inputNumber
          formControlName="graceDays"
          inputId="graceDays"
          [useGrouping]="false"
          [min]="0"
          class="w-full"
          placeholder="Ex: 0, 3, 5..."
        ></p-inputNumber>
        <app-form-error [control]="formGroup.get('graceDays')" />
        <app-form-server-error [control]="formGroup.get('graceDays')" />
      </div>

      <div class="w-full">
        <label for="isTaxable"> Tributável</label>
        <div class="flex gap-2 items-center mt-2">
          <p-toggleswitch formControlName="isTaxable" inputId="isTaxable" />
          {{ formGroup.get("isTaxable")!.value ? "Sim" : "Não" }}
        </div>
      </div>
    </div>
  </div>

  @if(loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>
